import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
//
//
//
//
//
//
//

import Vue from 'vue';
import filters from '@/utils/filters';
import Analytics from '@/utils/Analytics';
import { openWhiteScreen } from 'drip/utils/whiteScreen';
import { owlReportError } from '@/utils/monitor-err/index';

// globalMixin
import $ from 'zepto';
import Drip from 'drip';
import Toast from '@myfe/vue2-toast';
import '@myfe/vue2-toast/lib/toast.css';
require('@/common/global.mixin');

// vue 过滤器
Object.keys(filters).forEach(function (key, index) {
  Vue.filter(key, filters[key]);
});
Vue.use(Toast, {
  type: 'center',
  duration: 1500,
  wordWrap: true,
  width: 'auto'
});
var whiteScreenCleanup = null;
export default {
  name: 'app',
  created: function created() {
    this.setShenzhenIcbcParams();
    document.querySelector('body').setAttribute(this.themeName, '');
    $(document).off().on('click', '[data-href]', function (e) {
      Drip.redirect($(this).data('href'));
    });
  },
  mounted: function mounted() {
    // this.startWhiteScreen();
  },
  watch: {
    $route: function $route(newVal, oldVal) {
      if (newVal && oldVal && newVal.name && oldVal.name && newVal.name !== oldVal.name) {
        // 暂时只开放品类和榜单页面的白屏监测，后续根据需要增加
        if (['list', 'topList'].includes(newVal.name)) {
          try {
            this.cleanWhiteScreen();
            this.startWhiteScreen();
          } catch (e) {
            whiteScreenCleanup = null;
          }
        } else {
          this.cleanWhiteScreen();
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanWhiteScreen();
  },
  methods: {
    cleanWhiteScreen: function cleanWhiteScreen() {
      if (whiteScreenCleanup) {
        whiteScreenCleanup();
        whiteScreenCleanup = null;
      }
    },
    startWhiteScreen: function startWhiteScreen() {
      this.$nextTick(function () {
        try {
          var result = openWhiteScreen(function (res) {
            if (res.status === 'error') {
              owlReportError('', new Error('监测页面疑似白屏'));
            }
          }, {});
          whiteScreenCleanup = result && result.cleanup;
        } catch (e) {
          whiteScreenCleanup = null;
        }
      });
    },
    setShenzhenIcbcParams: function setShenzhenIcbcParams() {
      var _Drip$UA;
      if ((_Drip$UA = Drip.UA) !== null && _Drip$UA !== void 0 && _Drip$UA.IS_SHENZHEN_ICBC) {
        var _window$location;
        var url = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href;
        var queryString = url.split('?')[1]; // 获取问号后面的部分

        if (!queryString) return;
        var params = new URLSearchParams(queryString);
        var bankEncryKey = params.get('bankEncryKey');
        var bankEncryData = params.get('bankEncryData');
        var bankSignMsg = params.get('bankSignMsg');

        // 深圳工行员工福利app带过来的3个参数
        if (bankEncryKey && bankEncryData && bankSignMsg) {
          sessionStorage.setItem('shenzhenIcbcParams', JSON.stringify({
            bankEncryKey: bankEncryKey,
            bankEncryData: bankEncryData,
            bankSignMsg: bankSignMsg
          }));
        }
      }
    }
  },
  computed: {
    themeName: function themeName() {
      var appType = this.Constant.appType;
      var themeNameMap = {
        1: '__dianping_theme__',
        2: '__meituan_theme__',
        3: '__dianping_theme__',
        5: '__maoyan_theme__',
        6: '__maoyan_theme__',
        13: '__maoyan_theme__',
        8: '__gewara_theme__',
        27: '__maoyan_theme__',
        28: '__maoyan_theme__'
      };
      return themeNameMap[appType];
    }
  }
};